module.exports = __webpack_public_path__ + "static/media/course-arrow-up.3a61eb7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Courses/course-arrow-up.svg
// module id = 123
// module chunks = 0